import { isProduction } from 'utils/isProd';

export const VAULT_PORTAL_URL = isProduction() ? process.env.REACT_APP_VAULT : 'http://localhost:8443';
export const VAULT_SERVICE_URL = isProduction() ? process.env.REACT_APP_VAULT : 'http://localhost:5000';
export const USER_PROFILE_URL = `${VAULT_PORTAL_URL}/user/profile`;
export const LOGIN_URL = `${VAULT_PORTAL_URL}/login?redirect_url=`;
export const VAULT_API_URL = `${VAULT_SERVICE_URL}/api/vault`;
